<template>
  <button class="button-style" type="button" v-on:click="gotosite()">▶ Watch or Listen Now</button>
</template>

<script>
export default {
  methods: {
    gotosite () {
      window.open('https://3abnplus.tv/catalog', '_blank')
    }
  }
}
</script>
<style>
.button-style {
    background-color: #1458c0;
    color: white;
    padding: 5px;
    }
</style>
